var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('priority-select',{attrs:{"confirm":_vm.confirm,"clearable":_vm.clearable},on:{"change":_vm.onChange}},[_c('div',{class:_vm.cls},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }